import React from 'react';
import { Metadata } from '@thd-olt-component-react/metadata';
import { EmtDescription } from '@thd-olt-component-react/emt-generated-content';
import { Col, Heading, Row } from '@thd-olt-component-react/core-ui';
import PropTypes from 'prop-types';
import { useDataModel } from '@thd-nucleus/data-sources';
import { PrivacyMetadata } from '../PrivacyMetadata';
import { imageBaseUrl } from '../../../constants';
import './ThirdPartyDisclosure.scss';
import { dataModel } from '../../../contentful/dataModel/dataModel';

export const ThirdPartyDisclosure = ({ contentfulEnabled }) => {

  const metadata = {
    title: 'Third-Party Disclosure List - The Home Depot',
    // eslint-disable-next-line max-len
    description: 'For Rhode Island residents, you are able to review third-party companies that may result in the sale of your personal information.',
    canonical: 'https://www.homedepot.com/privacy/third-party-disclosure-list'
  };

  let cmsData;

  if (contentfulEnabled) {
    let customerType = 'b2c';
    let pageId = 'privacy/third-party-disclosure-list';
    const { data, loading, error } = useDataModel('layouts', {
      variables: {
        slug: pageId,
        customerType,
      },
    });

    cmsData = data;
  }

  return (
    <div style={{ backgroundColor: '#F5F5F5' }}>
      <Metadata>
        <PrivacyMetadata
          title={metadata.title}
          description={metadata.description}
          canonical={metadata.canonical}
        />
      </Metadata>
      <div className="third-party-container">
        <div className="cdg-content--header">
          <Heading className="cdg-header">
            <img
              height="40"
              width="40"
              alt="Privacy ToolBox"
              src={imageBaseUrl + '/PrivacyToolbox_logo_CLR.svg'}
              style={{ marginRight: '10px' }}
            />
            Third Parties Where Disclosure Results in the Sale of Personal Information
          </Heading>
        </div>
      </div>
      <div className="cdg-content--body">
        <Row className="white margin-20">
          {contentfulEnabled ? (
            <Col className="content-title">
              <EmtDescription
                title={cmsData?.layouts?.content?.richText[0]?.title}
                descriptionRichText={cmsData?.layouts?.content?.richText[0]?.description}
              />
              <Row>
                <Col xs="6" sm="3" md="3" lg="3">
                  <EmtDescription
                    title={cmsData?.layouts?.content?.richText[1]?.title}
                    descriptionRichText={cmsData?.layouts?.content?.richText[1]?.description}
                  />
                </Col>
                <Col xs="6" sm="3" md="3" lg="3">
                  <EmtDescription
                    title={cmsData?.layouts?.content?.richText[2]?.title}
                    descriptionRichText={cmsData?.layouts?.content?.richText[2]?.description}
                  />
                </Col>
              </Row>
            </Col>
          ) : (
            <Col className="content-title">
              <h1>Specific Third-Party List</h1>
              <br />
              <p>
                For business purposes described in our Privacy and Security Statement, we may
                disclose the information that we collect to help achieve those purposes with third
                parties that result in the sale of your personal information as defined by Rhode
                Island. We may, in the ordinary course of business, sell personal information
                associated with customers to the third parties listed below. We may sell the
                information automatically via cookies and similar technologies when you visit our
                website or via other channels.
              </p>
              <br />
              <p>
                The inclusion of a third-party below does not mean that your personal information
                has been sold to that specific third-party. For example, even if you have opted out
                of the sale of your personal information, in the list below you may see third parties
                listed below because we sell the personal information of other customers to such
                third parties.
              </p>
              <br />
              <p>
                Inactive third parties are those we made disclosures to in the past that may have
                resulted in the sale of personal information, but we no longer provide personal
                information to these entities or no longer provide it in a manner that results in a
                sale.
              </p>

              <Row>
                <Col xs="6" sm="3" md="3" lg="3">
                  <table>
                    <thead>
                      <tr>
                        <th>Active Third Parties</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr><td>A&E</td></tr>
                      <tr><td>Acast</td></tr>
                      <tr><td>AdsWizz Inc.</td></tr>
                      <tr><td>AdTheorent, Inc.</td></tr>
                      <tr><td>Alphabet Inc.</td></tr>
                      <tr><td>AMC Networks Inc.</td></tr>
                      <tr><td>Amobee</td></tr>
                      <tr><td>Ampersand</td></tr>
                      <tr><td>Audacy</td></tr>
                      <tr><td>Canela Media, Inc.</td></tr>
                      <tr><td>Comcast Corporation</td></tr>
                      <tr><td>Dax</td></tr>
                      <tr><td>DirecTV, LLC</td></tr>
                      <tr><td>Disney Advertising Sales, LLC</td></tr>
                      <tr><td>Dotdash Meredith</td></tr>
                      <tr><td>Dstillery</td></tr>
                      <tr><td>Estrella</td></tr>
                      <tr><td>Freewheel</td></tr>
                      <tr><td>GoDigital Media Group - Latido Networks</td></tr>
                      <tr><td>GumGum, Inc.</td></tr>
                      <tr><td>Ibotta, Inc.</td></tr>
                      <tr><td>iHeartMedia, Inc.</td></tr>
                      <tr><td>Innervate</td></tr>
                      <tr><td>Kargo Global Ltd.</td></tr>
                      <tr><td>LinkedIn Corporation</td></tr>
                      <tr><td>Mayfair Equity Partners</td></tr>
                      <tr><td>Meta Platforms, Inc.</td></tr>
                      <tr><td>Microsoft Corporation</td></tr>
                      <tr><td>Netflix, Inc.</td></tr>
                      <tr><td>Nextdoor, Inc.</td></tr>
                      <tr><td>Omnicom Media Group Holdings Inc.</td></tr>
                      <tr><td>Pandora Media, LLC</td></tr>
                      <tr><td>Paramount</td></tr>
                      <tr><td>Pinterest, Inc.</td></tr>
                      <tr><td>Reddit, Inc.</td></tr>
                      <tr><td>Roku, Inc.</td></tr>
                      <tr><td>Samsung Electronics Co., Ltd.</td></tr>
                      <tr><td>Snap, Inc.</td></tr>
                      <tr><td>Spotify Technology SA</td></tr>
                      <tr><td>The Trade Desk, Inc.</td></tr>
                      <tr><td>TikTok Inc.</td></tr>
                      <tr><td>Univision Communications Inc.</td></tr>
                      <tr><td>Vevo LLC</td></tr>
                      <tr><td>ViacomCBS EyeQ</td></tr>
                      <tr><td>VideoAmp</td></tr>
                      <tr><td>Vizio, Inc.</td></tr>
                      <tr><td>WarnerMedia, LLC</td></tr>
                      <tr><td>Yahoo Ad Tech LLC</td></tr>
                    </tbody>
                  </table>
                </Col>
                <Col xs="6" sm="3" md="3" lg="3">
                  <table>
                    <thead>
                      <tr>
                        <th>Inactive Third Parties</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr><td>AcuityAds Inc.</td></tr>
                      <tr><td>Bridg, Inc.</td></tr>
                      <tr><td>Crackle Plus, LLC</td></tr>
                      <tr><td>Entravision Communications Corporation</td></tr>
                      <tr><td>Kortx</td></tr>
                      <tr><td>Nexstar Media Group, Inc.</td></tr>
                      <tr><td>Sabio, Inc.</td></tr>
                      <tr><td>Semasio</td></tr>
                      <tr><td>Tapad Inc.</td></tr>
                      <tr><td>TargetSpot, Inc.</td></tr>
                      <tr><td>Turn Inc.</td></tr>
                      <tr><td>Zeta</td></tr>
                    </tbody>
                  </table>
                </Col>
              </Row>
            </Col>
          )}
        </Row>
      </div>
    </div>
  );
};

ThirdPartyDisclosure.propTypes = {
  contentfulEnabled: PropTypes.bool
};

ThirdPartyDisclosure.defaultProps = {
  contentfulEnabled: false
};

ThirdPartyDisclosure.dataModel = dataModel;
